<script>
/**
 * 首页 Hero 轮播（自 vancheen-b2b 的 HeroCarousel.vue 移植为 Vue 2 版本）
 * 手写交互参数保持一致：自动 5.2s、hover 暂停、左右箭头；
 * 外观（圆形毛玻璃箭头 / 圆点→长条指示器）由 nh-theme.css 还原。
 */
import NhCtaButton from './NhCtaButton.vue'
import asset from '../nh-asset'

export default {
  name: 'NhHeroCarousel',
  components: { NhCtaButton },
  props: {
    slides: { type: Array, required: true }
  },
  methods: {
    asset
  }
}
</script>

<template>
  <section class="hero">
    <el-carousel :interval="5200" arrow="always" :pause-on-hover="true">
      <el-carousel-item v-for="(slide, i) in slides" :key="i">
        <div class="hero-slide">
          <img :src="asset(slide.img)" :alt="slide.alt">
          <div class="hero-content">
            <span class="eyebrow">{{ slide.eyebrow }}</span>
            <!-- 标题/副标题含品牌色高亮片段，沿用原站的内联标记 -->
            <h1 v-html="slide.titleHtml" />
            <p class="hero-sub" v-html="slide.subHtml" />
            <div class="hero-ctas">
              <NhCtaButton
                v-for="cta in slide.ctas"
                :key="cta.label"
                :label="cta.label"
                :to="cta.to"
                :variant="cta.cls"
              />
            </div>
            <div class="hero-tags">
              <span v-for="tag in slide.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>
